import { Flex } from 'antd'
import { useTranslation } from 'react-i18next'

import { useStocksServiceGetInternalInquiryListEndpoint } from 'src/api/queries'
import { InternalInventoryDocumentState } from 'src/api/requests'
import { Text } from 'src/components'
import { useStyles } from 'src/features/stock/components/stock/styles'

type Props = {
  quantity: number
}

export const QuantityPopover = ({ quantity }: Props) => {
  const { styles } = useStyles()

  const { t } = useTranslation()
  const { data } = useStocksServiceGetInternalInquiryListEndpoint(
    {
      states: [InternalInventoryDocumentState.WAITING]
    },
    []
  )

  const totalQuantity = data?.data
    ? data.data.reduce((total, inquiry) => {
        const inquiryTotal =
          inquiry?.items?.reduce(
            (sum, item) => sum + (item.quantity || 0),
            0
          ) || 0

        return total + inquiryTotal
      }, 0)
    : 0

  const aggregatedData = data?.data?.reduce<Record<string, number>>(
    (acc, inquiry) => {
      const institutionName = inquiry?.role?.name

      if (institutionName) {
        const itemCount = inquiry?.items?.length

        acc[institutionName] = (acc[institutionName] || 0) + (itemCount ?? 0)
      }

      return acc
    },
    {}
  )

  const totalInquiries =
    data?.data?.reduce((total, inquiry) => {
      const itemCount = inquiry?.items?.length ?? 0

      return total + itemCount
    }, 0) ?? 0

  return (
    <Flex vertical className={styles.wrapper}>
      <Flex vertical className={styles.totalCapacity}>
        <Flex justify="space-between" className={styles.textBlock}>
          <Text color="white" weight={400}>
            {t('stock_local.local_quantity')}
          </Text>
          <Text weight={400} color="white">
            {quantity === 0 ? totalQuantity : quantity}
          </Text>
        </Flex>
      </Flex>
      {!!data?.totalCount && (
        <Flex vertical className={styles.entries}>
          <Flex justify="space-between" className={styles.textBlock}>
            <Text color="white" weight={400}>
              {t('stock.filled_requests')}
            </Text>
            <Text weight={400} color="white">
              {totalInquiries}
            </Text>
          </Flex>

          <ul className={styles.list}>
            {Object.entries(aggregatedData ?? []).map(
              ([institutionName, quantity]) => (
                <li key={institutionName}>
                  <Flex
                    gap={8}
                    justify="space-between"
                    className={styles.textBlock}
                  >
                    <Text weight={400} color="white" ellipsis>
                      {institutionName}
                    </Text>
                    <Text weight={400} color="white">
                      {quantity}
                    </Text>
                  </Flex>
                </li>
              )
            )}
          </ul>
        </Flex>
      )}
    </Flex>
  )
}
